import * as React from 'react'
import { connect } from 'react-redux'
import {
    CardBody,
    Row,
    CardHeader,
    Col,
    Collapse,
    Input,
    Label, Form, FormGroup
} from "reactstrap";
import {WithTranslation, withTranslation} from "react-i18next";
import {CurrencyProps, FULLSERVICE_MONTHS} from "App/constants";
import {basketFullServiceSelectionChange} from "App/basket";
import {ConfiguratorProductFullservice, CurrentConfigurationFullservice} from "App/services/api";

interface StateToProps extends CurrencyProps {
    fullService: CurrentConfigurationFullservice | undefined
    fullServiceDefinition: ConfiguratorProductFullservice
}

interface DispatchToProps {
    onSelectFullService: (selected: boolean, durationmonths: number|undefined, hoursperyear: number|undefined) => void
}

const mapDispatchToProps = (dispatch: any) : DispatchToProps => ({
    onSelectFullService: (selected: boolean, durationmonths: number|undefined, hoursperyear: number|undefined) => dispatch(basketFullServiceSelectionChange(selected, durationmonths, hoursperyear))
});

interface ComponentState {
    isVisible: boolean
    hoursPerYear?: number
    isHoursPerYearValid: boolean
}

function initialState (props: StateToProps): ComponentState {
    return {
        isVisible: !!props.fullService,
        isHoursPerYearValid: true
    }
}

class _Component extends React.PureComponent<StateToProps & DispatchToProps & WithTranslation, ComponentState> {

    constructor(props: StateToProps & DispatchToProps & WithTranslation, context: any) {
        super(props, context);
        this.state = initialState(props);
        this.checkSelectFullService = this.checkSelectFullService.bind(this);
    }

    toggleVisibility() {
        this.setState((state, props) => ({
            isVisible: !state.isVisible
        }));
    }

    checkSelectFullService(selected: boolean, durationmonths: number|undefined, hoursperyear: number|undefined) {
        const {fullServiceDefinition, onSelectFullService} = this.props;

        // If the data is ok, go ahead
        if (hoursperyear&&hoursperyear>=fullServiceDefinition.minhoursperyear&&hoursperyear<=fullServiceDefinition.maxhoursperyear){
            onSelectFullService(selected, durationmonths, hoursperyear);
            this.setState({hoursPerYear:undefined, isHoursPerYearValid: true})
        } else {
            this.setState({hoursPerYear:hoursperyear, isHoursPerYearValid: false})
        }
    }

    render() {
        const {t, currency, fullService, fullServiceDefinition} = this.props;

        var currentHoursPerYear: number|undefined = this.state.isHoursPerYearValid?(fullService&&fullService.hoursperyear)||fullServiceDefinition.minhoursperyear:this.state.hoursPerYear;
        var currentDurationMonths: number = fullService&&fullService.durationmonths||FULLSERVICE_MONTHS[0];
        return <React.Fragment>
            <CardHeader className="px-5 d-flex align-items-center py-3 bg-white toggable" onClick={() => this.toggleVisibility()}>
                <span className="m-0 w-75 float-left title-normal-uppercase">{ t('products.configuration.fullservice')}</span>
                <i className={'far fa-lg w-25 text-right ' + (this.state.isVisible? 'fa-chevron-up' : 'fa-chevron-down')}></i>
            </CardHeader>
            <Collapse isOpen={this.state.isVisible}>
                <CardBody className="px-5 pt-2 pb-3 bodyslice">
                    <Row className="no-gutters">
                        <Col className="align-items-center py-2 pr-0 col-sm-8">
                            <div className="form-check">
                                <Input type="checkbox" checked={!!fullService} id={"optionInputFullService"} name={"optionInputFullService"} className="align-middle"
                                       onChange={(e) => this.checkSelectFullService(e.target.checked, currentDurationMonths, currentHoursPerYear)}/>
                                <Label htmlFor={"optionInputFullService"} className="py-0 text-normal-details light align-middle">{ t('products.configuration.includefullservice')}</Label>
                            </div>
                        </Col>
                        <Col className="align-items-center py-2 pl-0 col-sm-4 text-right">
                            <Label className="pl-2 py-0 text-normal-details light align-middle">{fullService&&fullService.monthlyrate?t('products.configuration.fullserviceprice', {amount:fullService.monthlyrate, unit:currency}):null}</Label>
                        </Col>
                    </Row>
                    <Row className="no-gutters">
                        <Col className="align-items-center pr-0 col-sm-6">
                            <Form inline>
                                <FormGroup>
                                    <Label for="fullServiceDuration" className={"text-normal-details light pl-5"}>{ t('products.configuration.fullserviceduration')}</Label>
                                    <Input type="select" name="fullServiceDuration" id="fullServiceDuration" disabled={!fullService} className={"text-select-details light ml-3"}
                                           value={currentDurationMonths}
                                           onChange={(e) => this.checkSelectFullService(true, e.target.value?Number(e.target.value):undefined, currentHoursPerYear)}>
                                        {
                                            FULLSERVICE_MONTHS.map((month:number, index: number) => (
                                                <option key={month} value={month}>{t('products.configuration.fullservicemonth', {month: month})}</option>
                                            ))
                                        }
                                    </Input>
                                </FormGroup>
                            </Form>
                        </Col>
                        <Col className="align-items-center pl-0 col-sm-6">
                            <Form inline>
                                <FormGroup>
                                    <Label for="fullServiceHours" className={"text-normal-details light pl-5"}>{ t('products.configuration.fullservicehoursperyear')}</Label>
                                    <Input type="number" name="fullServiceHours" id="fullServiceHours" disabled={!fullService} className={"text-select-details light ml-3"}
                                           value={currentHoursPerYear} onChange={(e) => this.checkSelectFullService(true, currentDurationMonths, e.target.value?Number(e.target.value):undefined)}
                                           onBlur={(e) => this.checkSelectFullService(true, currentDurationMonths, (fullService&&fullService.hoursperyear)||fullServiceDefinition.minhoursperyear)}>
                                    </Input>
                                </FormGroup>
                            </Form>
                        </Col>
                    </Row>
                </CardBody>
            </Collapse>
        </React.Fragment>
    }
}

export const Component = connect(null, mapDispatchToProps)(withTranslation('common')(_Component));


// WEBPACK FOOTER //
// ./src/components/FullService.tsx